class AjaxSearch {
  constructor() {
    this.selectors = {
      searchForm: '#header-search form',
      searchInput: '#header-search input[type="search"]',
      searchContainer: '#header-search',
      searchResultsContainer: '[data-nav-search-results]',
      searchCollectionsContainer: '#suggested-collections'
    };

    this.classes = {
      isSearching: 'is-searching',
      pushUp: 'push-up'
    };

    this.abortController = null;
    this.isLoading = false;
    this.currentQuery = '';
    this.resultsPerPage = 250;
    this.debounceTimer = null;
    this.originalProductResults = null;
    this.collectionHoverTimeout = null;

    this.init();
  }

  init() {
    this.setupEventListeners();
    this.setupTopCollectionHover();
  }

  setupTopCollectionHover() {
    if (window.innerWidth <= 992) {
      return;
    }

    setTimeout(() => {
      const topCollectionItems = document.querySelectorAll('.top-search-collections .collection-results__item[data-collection-handle]');
      
      topCollectionItems.forEach((item) => {
        if (!item) {
          return;
        }
        
        item.addEventListener('mouseenter', (e) => {
          if (window.innerWidth <= 992) {
            return;
          }

          const target = e.currentTarget || e.target;
          
          if (!target) {
            return;
          }
          
          const handle = target.getAttribute('data-collection-handle');
          const url = target.getAttribute('data-collection-url');
          
          if (!handle || !url) {
            return;
          }
          
          if (this.collectionHoverTimeout) {
            clearTimeout(this.collectionHoverTimeout);
          }
          
          this.collectionHoverTimeout = setTimeout(() => {
            this.loadCollectionProducts(handle, url);
          }, 300);
        });
        
        item.addEventListener('mouseleave', () => {
          if (this.collectionHoverTimeout) {
            clearTimeout(this.collectionHoverTimeout);
            this.collectionHoverTimeout = null;
          }
        });
      });
    }, 500);
  }

  setupEventListeners() {
    // See More button functionality
    const seeMoreButton = document.querySelector('.see-more-button');
    if (seeMoreButton) {
      seeMoreButton.addEventListener('click', this.handleSeeMoreClick.bind(this));
    }

    // Search input functionality
    const searchInput = document.querySelector(this.selectors.searchInput);
    if (searchInput) {
      searchInput.addEventListener('input', (event) => {
        const searchTerm = event.target.value.trim();
        
        if (this.debounceTimer) {
          clearTimeout(this.debounceTimer);
        }
        
        if (searchTerm) {
          this.debounceTimer = setTimeout(() => {
            this.currentQuery = searchTerm;
            this.request(searchTerm);
          }, 300);
        } else {
          this.clearSearchResults();
        }
      });
    }

    // Handle search open/close events
    const searchContainer = document.querySelector(this.selectors.searchContainer);
    if (searchContainer) {
      // Watch for Alpine.js changes to active class
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'class') {
            const isActive = searchContainer.classList.contains('active');
            if (isActive) {
              document.documentElement.classList.add('search-active');
              document.body.classList.add('search-active');
            } else {
              document.documentElement.classList.remove('search-active');
              document.body.classList.remove('search-active');
            }
          }
        });
      });

      observer.observe(searchContainer, { attributes: true });
    }

    // Handle close button
    const closeButton = document.querySelector('#close-header-search');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        this.closeSearch();
      });
    }

    const handleReset = () => {
      this.clearSearchResults();
      const searchResultsContainer = document.querySelector(this.selectors.searchResultsContainer);
      if (searchResultsContainer) {
        searchResultsContainer.style.display = 'none';
      }
    };

    const resetButton = document.querySelector('#header-search .reset__button');
    if (resetButton) {
      resetButton.addEventListener('click', handleReset);
    }

    document.addEventListener('search-input-cleared', handleReset);
  }

  handleSeeMoreClick(event) {
    const resultsPopular = document.querySelector('.results-popular.hide-catalog');
    if (!resultsPopular) return;

    const isVisible = resultsPopular.style.display !== 'none';

    if (isVisible) {
      resultsPopular.style.display = 'none';
      event.target.textContent = 'See More';
    } else {
      resultsPopular.style.display = 'block';
      event.target.textContent = 'See Less';
    }
  }

  // Add function to close search and restore scrolling
  closeSearch() {
    const headerSearch = document.querySelector(this.selectors.searchContainer);
    if (headerSearch && headerSearch.classList.contains('active')) {
      headerSearch.classList.remove('active');
      // Remove search-active class from html and body
      document.documentElement.classList.remove('search-active');
      document.body.classList.remove('search-active');
    }
  }

  clearSearchResults() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = null;
    }
    
    if (this.abortController) {
      this.abortController.abort();
      this.abortController = null;
    }
    
    const searchResultsContainer = document.querySelector(this.selectors.searchResultsContainer);
    if (searchResultsContainer) {
      searchResultsContainer.innerHTML = '';
      searchResultsContainer.style.display = 'none';
    }
    
    const collectionsContainer = document.querySelector(this.selectors.searchCollectionsContainer);
    if (collectionsContainer) {
      collectionsContainer.innerHTML = '';
    }
    
    const showAllResultsDiv = document.querySelector('.show-all-results');
    if (showAllResultsDiv) {
      showAllResultsDiv.style.display = 'none';
    }
    
    this.restoreOriginalProductResults();
    
    const topCollectionsDiv = document.querySelector('[data-top-collections]');
    const topProductsDiv = document.querySelector('[data-top-products]');
    
    if (topCollectionsDiv) {
      topCollectionsDiv.style.display = '';
    }
    if (topProductsDiv) {
      topProductsDiv.style.display = '';
    }
    
    if (this.collectionHoverTimeout) {
      clearTimeout(this.collectionHoverTimeout);
      this.collectionHoverTimeout = null;
    }
    
    const searchContainer = document.querySelector(this.selectors.searchContainer);
    if (searchContainer) {
      searchContainer.classList.remove(this.classes.isSearching, this.classes.pushUp);
    }

    this.currentQuery = '';
    this.isLoading = false;
  }

  request(searchQuery) {
    const searchResultsContainer = document.querySelector(this.selectors.searchResultsContainer);
    const searchContainer = document.querySelector(this.selectors.searchContainer);

    if (!searchResultsContainer || !searchContainer) {
      return;
    }

    // Clear previous results and show container
    searchResultsContainer.innerHTML = '';
    searchResultsContainer.style.display = '';

    // Add the loading indicator with SVG and animated dots
    const loadingHTML = `
      <div class="pagination__loading">
        <div class="loading-text">
          Loading more
          <span class="dots dots--animated">
            <span>.</span>
            <span>.</span>
            <span>.</span>
          </span>
        </div>
      </div>
    `;
    searchResultsContainer.innerHTML = loadingHTML;

    // Show searching state
    searchContainer.classList.add(this.classes.isSearching);

    // Set loading state
    this.isLoading = true;

    if (this.abortController) {
      this.abortController.abort();
    }

    this.abortController = new AbortController();

    const searchUrl = `/search?view=view-json&q=${encodeURIComponent(searchQuery)}&limit=${this.resultsPerPage}&page=1`;

    fetch(searchUrl, {
      signal: this.abortController.signal
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`Search API returned status ${response.status}`);
        }
        return response.text();
      })
      .then(text => {
        try {
          let jsonText = text;
          const jsonStart = text.indexOf('{');
          const jsonEnd = text.lastIndexOf('}') + 1;

          if (jsonStart >= 0 && jsonEnd > jsonStart) {
            jsonText = text.substring(jsonStart, jsonEnd);
          }

          return JSON.parse(jsonText);
        } catch (e) {
          // Try alternative approach with .json format
          const alternativeUrl = `/search.json?q=${encodeURIComponent(searchQuery)}&limit=${this.resultsPerPage}`;

          return fetch(alternativeUrl)
            .then(response => response.json())
            .then(jsonData => {
              return this.convertShopifyApiFormat(jsonData, searchQuery);
            })
            .catch(jsonError => {
              // Try fallback to standard json liquid template
              return fetch(`/search?view=json&q=${encodeURIComponent(searchQuery)}&limit=${this.resultsPerPage}`)
                .then(response => response.text())
                .then(fallbackText => {
                  try {
                    let jsonText = fallbackText;
                    const jsonStart = fallbackText.indexOf('{');
                    const jsonEnd = fallbackText.lastIndexOf('}') + 1;

                    if (jsonStart >= 0 && jsonEnd > jsonStart) {
                      jsonText = fallbackText.substring(jsonStart, jsonEnd);
                    }

                    return JSON.parse(jsonText);
                  } catch (fallbackError) {
                    throw new Error('Invalid JSON response from search endpoints');
                  }
                });
            });
        }
      })
      .then(data => {
        this.originalProductResults = null;
        let searchResultsContent = '';

        const topCollectionsDiv = document.querySelector('[data-top-collections]');
        const topProductsDiv = document.querySelector('[data-top-products]');
        
        if (topCollectionsDiv) {
          topCollectionsDiv.style.display = 'none';
        }
        if (topProductsDiv) {
          topProductsDiv.style.display = 'none';
        }

        const allProductResults = data.results.filter(item => item.object_type === 'product');
        let allCollectionResults = data.results.filter(item => item.object_type === 'collection');
        const totalProductCount = allProductResults.length;
        
        const collectionSearchUrl = `/search?view=collections-json&q=${encodeURIComponent(searchQuery)}`;
        
        fetch(collectionSearchUrl)
          .then(response => {
            if (!response.ok) {
              throw new Error(`Collection search returned status ${response.status}`);
            }
            return response.text();
          })
          .then(text => {
            try {
              let jsonText = text;
              const jsonStart = text.indexOf('{');
              const jsonEnd = text.lastIndexOf('}') + 1;
              if (jsonStart >= 0 && jsonEnd > jsonStart) {
                jsonText = text.substring(jsonStart, jsonEnd);
              }
              const collectionData = JSON.parse(jsonText);
              const collectionSearchResults = collectionData.results.filter(item => item.object_type === 'collection');
              
              if (collectionSearchResults.length > 0) {
                allCollectionResults = collectionSearchResults;
              }
            } catch (e) {
              // Fallback to existing collection results
            }
          })
          .catch(err => {
            // Fallback to existing collection results
          })
          .finally(() => {
            const collectionsContainer = document.querySelector(this.selectors.searchCollectionsContainer);
            if (collectionsContainer) {
              if (allCollectionResults.length > 0) {
                collectionsContainer.innerHTML = this.getCollectionResultsContent(allCollectionResults.slice(0, 5), searchQuery);
              } else {
                collectionsContainer.innerHTML = '';
              }
            }
          });
        
        const productResults = allProductResults.slice(0, 5);
        const displayCount = productResults.length;
        const hasResults = displayCount > 0 || allCollectionResults.length > 0;

        const showAllResultsDiv = document.querySelector('.show-all-results');
        if (showAllResultsDiv) {
          if (hasResults) {
            showAllResultsDiv.style.display = '';
          } else {
            showAllResultsDiv.style.display = 'none';
          }
        }

        if (displayCount > 0) {
          const resultsText = totalProductCount == 1
            ? totalProductCount + ' result'
            : totalProductCount + ' results';

          searchResultsContent += '<div class="results__count">' + resultsText + '</div>';
          searchResultsContent += '<div class="product-results__list">' + this.getResultsContent({ ...data, results: productResults }) + '</div>';
        } else {
          searchResultsContent = '<p class="no-results">No results found for "' + searchQuery + '". Check the spelling or use a different word or phrase for '+ searchQuery +'</p>';
        }

        searchResultsContainer.innerHTML = searchResultsContent;
        this.originalProductResults = searchResultsContent;
        searchContainer.classList.remove(this.classes.isSearching);

        // Set loading state
        this.isLoading = false;
      })
      .catch(error => {
        if (error.name === 'AbortError') {
          return;
        }

        // Show error message
        searchResultsContainer.innerHTML = '<div class="results-empty">Error retrieving search results: ' + error.message + '. Please try again.</div>';
        searchContainer.classList.remove(this.classes.isSearching);

        const showAllResultsDiv = document.querySelector('.show-all-results');
        if (showAllResultsDiv) {
          showAllResultsDiv.style.display = 'none';
        }

        // Set loading state
        this.isLoading = false;
      });
  }

  // Helper method to convert from Shopify Search API format to our expected format
  convertShopifyApiFormat(shopifyData, searchQuery) {
    if (!shopifyData || !shopifyData.resources || !shopifyData.resources.results) {
      return { results: [] };
    }

    const results = shopifyData.resources.results.products.map(product => {
      return {
        title: product.title,
        url: `/products/${product.handle}`,
        featured_image: product.image ? product.image.src : null,
        image_aspectratio: product.image ? '1/1' : '1/1', // Default aspect ratio
        available: product.available,
        price: product.price_min,
        compare_at_price: product.compare_at_price_min || product.price_min,
        object_type: 'product'
      };
    });

    return {
      results: results,
      query: searchQuery,
      next_page: null
    };
  }

  getResultsContent(data) {
    let searchResultsContent = '';

    for (let i = 0; i < data.results.length; i++) {
      const result = data.results[i];
      const title = result.title;
      const url = result.url;
      // Get image URL - use 600px width to match header.liquid
  //  const image = result.featured_image
  //  ? result.featured_image.replace(/_(\d+)x/, '_600x')
  //  : null;
      // 07/23/26 - updated to rem
      const image = result.featured_image;      
      // Generate price HTML
      let priceHTML = '';
      
      if (result.price_html) {
        priceHTML = result.price_html;
      } else {
        const price = result.price || 0;
        const compareAtPrice = result.compare_at_price || price;
        const isOnSale = compareAtPrice > price && result.available !== false;
        const formattedPrice = this.formatMoney(price);
        const formattedCompareAtPrice = this.formatMoney(compareAtPrice);

        if (isOnSale) {
          priceHTML = `
            <div class="price price--on-sale">
              <div class="price__container">
                <div class="price__regular">
                  <span class="visually-hidden visually-hidden--inline">Regular price</span>
                  <span class="price-item price-item--regular">${formattedPrice}</span>
                </div>
                <div class="price__sale">
                  <span class="visually-hidden visually-hidden--inline">Regular price</span>
                  <span><s class="price-item price-item--regular">${formattedCompareAtPrice}</s></span>
                  <span class="visually-hidden visually-hidden--inline">Sale price</span>
                  <span class="price-item price-item--sale price-item--last">${formattedPrice}</span>
                </div>
              </div>
            </div>
          `;
        } else {
          priceHTML = `
            <div class="price">
              <div class="price__container">
                <div class="price__regular">
                  <span class="visually-hidden visually-hidden--inline">Regular price</span>
                  <span class="price-item price-item--regular">${formattedPrice}</span>
                </div>
              </div>
            </div>
          `;
        }
      }

      // New structure matching header.liquid
      searchResultsContent += `
        <div class="product-results__item">
          <a href="${url}" class="product-results__link">
            ${image ?
          `<div class="product-results__image">
              <img src="${image}" alt="${title}" width="600" height="600" loading="lazy" class="product-results__image-img">
            </div>`
          :
          `<div class="product-results__image">
              <div class="product-results__image-img"></div>
            </div>`
        }
            <div class="product-results__content">
              <h4 class="product-results__title">${title}</h4>
              <div class="product-results__price">
                ${priceHTML}
              </div>
            </div>
          </a>
        </div>
      `;
    }

    return searchResultsContent;
  }

  getCollectionResultsContent(collections, searchQuery = '') {
    let collectionResultsContent = '';

    for (let i = 0; i < collections.length; i++) {
      const collection = collections[i];
      let title = collection.title;
      const url = collection.url;
      const handle = collection.handle || url.split('/collections/')[1]?.split('?')[0] || '';
      
      if (searchQuery && searchQuery.trim().length > 0) {
        const searchTerm = searchQuery.trim();
        const regex = new RegExp(`(${this.escapeRegex(searchTerm)})`, 'gi');
        title = title.replace(regex, '<mark>$1</mark>');
      }
      
      collectionResultsContent += `
        <a href="${url}" class="collection-results__item" data-collection-handle="${handle}" data-collection-url="${url}">
          ${title}
        </a>
      `;
    }
    
    setTimeout(() => {
      this.setupCollectionHover();
    }, 100);
    
    return collectionResultsContent;
  }

  setupCollectionHover() {
    if (window.innerWidth <= 992) {
      return;
    }

    const collectionItems = document.querySelectorAll('#suggested-collections .collection-results__item[data-collection-handle]');
    
    collectionItems.forEach((item) => {
      if (!item) {
        return;
      }
      
      item.addEventListener('mouseenter', (e) => {
        if (window.innerWidth <= 992) {
          return;
        }

        const target = e.currentTarget || e.target;
        
        if (!target) {
          return;
        }
        
        const handle = target.getAttribute('data-collection-handle');
        const url = target.getAttribute('data-collection-url');
        
        if (!handle || !url) {
          return;
        }
        
        if (this.collectionHoverTimeout) {
          clearTimeout(this.collectionHoverTimeout);
        }
        
        this.collectionHoverTimeout = setTimeout(() => {
          this.loadCollectionProducts(handle, url);
        }, 300);
      });
      
      item.addEventListener('mouseleave', () => {
        if (this.collectionHoverTimeout) {
          clearTimeout(this.collectionHoverTimeout);
          this.collectionHoverTimeout = null;
        }
      });
    });
  }

  loadCollectionProducts(collectionHandle, collectionUrl) {
    if (!collectionHandle) {
      return;
    }
    
    const searchResultsContainer = document.querySelector(this.selectors.searchResultsContainer);
    if (!searchResultsContainer) {
      return;
    }
    
    const suggestionsResults = document.querySelector('.suggestions-results');
    if (suggestionsResults) {
      suggestionsResults.style.display = 'none';
    }
    
    if (searchResultsContainer) {
      searchResultsContainer.style.display = '';
    }
    
    if (!this.originalProductResults) {
      this.originalProductResults = searchResultsContainer.innerHTML;
    }
    
    const collectionProductsUrl = `${collectionUrl}/products.json`;
    
    fetch(collectionProductsUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Collection products API returned status ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        let products = [];
        
        if (data && data.products && Array.isArray(data.products)) {
          products = data.products;
        } else if (data && data.collection && data.collection.products && Array.isArray(data.collection.products)) {
          products = data.collection.products;
        }
        
        const seenTitles = new Set();
        const uniqueProducts = [];
        
        for (const product of products) {
          const title = product.title ? product.title.trim() : '';
          if (title && !seenTitles.has(title)) {
            seenTitles.add(title);
            uniqueProducts.push(product);
            if (uniqueProducts.length >= 5) {
              break;
            }
          }
        }
        
        const displayProducts = uniqueProducts;
        let productsHTML = '';
        
        if (displayProducts.length > 0) {
          productsHTML += `<div class="results__count">${displayProducts.length} ${displayProducts.length === 1 ? 'product' : 'products'} from collection</div>`;
          productsHTML += '<div class="product-results__list">';
          
          displayProducts.forEach(product => {
            let image = null;
            if (product.images && product.images.length > 0) {
              image = product.images[0].src ? product.images[0].src.replace(/_(\d+)x/, '_600x') : null;
            } else if (product.featured_image) {
              image = product.featured_image.replace(/_(\d+)x/, '_600x');
            } else if (product.variants && product.variants.length > 0 && product.variants[0].featured_image) {
              image = product.variants[0].featured_image.src ? product.variants[0].featured_image.src.replace(/_(\d+)x/, '_600x') : null;
            }
            
            let price = 0;
            let compareAtPrice = 0;
            let available = false;
            
            if (product.variants && product.variants.length > 0) {
              const firstVariant = product.variants[0];
              price = firstVariant.price ? parseFloat(firstVariant.price) * 100 : 0;
              compareAtPrice = firstVariant.compare_at_price ? parseFloat(firstVariant.compare_at_price) * 100 : price;
              available = firstVariant.available !== false;
            }
            
            const isOnSale = compareAtPrice > price && available;
            const formattedPrice = this.formatMoney(price);
            const formattedCompareAtPrice = this.formatMoney(compareAtPrice);
            
            let priceHTML = '';
            if (isOnSale) {
              priceHTML = `
                <div class="price price--on-sale">
                  <div class="price__container">
                    <div class="price__regular">
                      <span class="visually-hidden visually-hidden--inline">Regular price</span>
                      <span class="price-item price-item--regular">${formattedPrice}</span>
                    </div>
                    <div class="price__sale">
                      <span class="visually-hidden visually-hidden--inline">Regular price</span>
                      <span>
                        <s class="price-item price-item--regular">${formattedCompareAtPrice}</s>
                      </span>
                      <span class="visually-hidden visually-hidden--inline">Sale price</span>
                      <span class="price-item price-item--sale price-item--last">${formattedPrice}</span>
                    </div>
                  </div>
                </div>
              `;
            } else {
              priceHTML = `
                <div class="price">
                  <div class="price__container">
                    <div class="price__regular">
                      <span class="visually-hidden visually-hidden--inline">Regular price</span>
                      <span class="price-item price-item--regular">${formattedPrice}</span>
                    </div>
                  </div>
                </div>
              `;
            }
            
            productsHTML += `
              <div class="product-results__item">
                <a href="/products/${product.handle}" class="product-results__link">
                  ${image ?
                  `<div class="product-results__image">
                      <img src="${image}" alt="${product.title}" width="600" height="600" loading="lazy" class="product-results__image-img">
                    </div>`
                  :
                  `<div class="product-results__image">
                      <div class="product-results__image-img"></div>
                    </div>`
                }
                  <div class="product-results__content">
                    <h4 class="product-results__title">${product.title}</h4>
                    <div class="product-results__price">
                      ${priceHTML}
                    </div>
                  </div>
                </a>
              </div>
            `;
          });
          
          productsHTML += '</div>';
          searchResultsContainer.innerHTML = productsHTML;
        } else {
          searchResultsContainer.innerHTML = '<p class="no-results">No products found in this collection.</p>';
        }
      })
      .catch(error => {
        const searchResultsContainer = document.querySelector(this.selectors.searchResultsContainer);
        if (searchResultsContainer) {
          searchResultsContainer.innerHTML = '<p class="no-results">Unable to load collection products.</p>';
        }
      });
  }

  restoreOriginalProductResults() {
    const searchResultsContainer = document.querySelector(this.selectors.searchResultsContainer);
    const suggestionsResults = document.querySelector('.suggestions-results');
    const searchInput = document.querySelector(this.selectors.searchInput);
    
    if (searchResultsContainer && this.originalProductResults) {
      searchResultsContainer.innerHTML = this.originalProductResults;
    }
    
    if (suggestionsResults) {
      const searchTerm = searchInput ? searchInput.value.trim() : '';
      if (!searchTerm || searchTerm === '') {
        suggestionsResults.style.display = '';
      } else {
        suggestionsResults.style.display = 'none';
      }
    }
  }

  escapeRegex(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  formatMoney(cents) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    const value = (cents / 100).toFixed(2);
    const moneyFormat = window.theme && window.theme.moneyFormat
      ? window.theme.moneyFormat
      : '${{amount}}';

    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, value);
  }
}

// Initialize search - compatible with lazy loading system
let searchInitialized = false;

function initializeSearch() {
  if (searchInitialized) return;
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (!searchInitialized) {
        new AjaxSearch();
        searchInitialized = true;
      }
    });
  } else {
    new AjaxSearch();
    searchInitialized = true;
  }
}

if (window.addEventListener) {
  window.addEventListener('wnw_load', initializeSearch, false);
}

initializeSearch(); 